import { boot } from "quasar/wrappers";

export default boot(({ app, router }) => {
  document.addEventListener("deviceready", () => {
    if (typeof window.universalLinks !== "undefined") {
      window.universalLinks.subscribe("launchedAppFromLink", (eventData) => {
        if (!eventData || !eventData.path) return;

        const path = eventData.path;
        const parts = path.split("/").filter(Boolean);

        if (parts[0] === "store-detail" && parts[1] && parts[2] === "my-deal") {
          router.push({ path });
          return;
        }

        if (
          path === "/my-deals" ||
          (path.includes("store-detail") && path.includes("deal-detail/store"))
        ) {
          router.push({ path });
        }
      });
    }
  });
});
